import { useEffect } from "react";
// import Header from "@/components/Header";
import HeroSection from "./HeroSection";
import HowItWorks from "./HowItWorks";
import ClientsSection from "./ClientsSection";
import FeaturedTools from "./FeaturedTools";
import Faq from "./Faq";
import MobileApps from "./MobileApps";
import Footer from "./Footer";
import SaparyaConferenceSection from "./SaparyaConferenceSection";
// import ScrollHeadlineSection from "./ScrollHeadlineSection";
// import StudentCards from "./UserProfileCard";
import "./Home.css";

const AnimatedSection = ({ children, delay = 0, variant = "up" }) => (
  <div
    className={`home-scroll-reveal home-reveal-${variant}`}
    style={{ transitionDelay: `${delay}ms` }}
  >
    {children}
  </div>
);

const Home = () => {
  useEffect(() => {
    const elements = Array.from(document.querySelectorAll(".home-scroll-reveal"));
    if (!elements.length) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-background home-shell">
      <div className="home-ambient home-ambient-left" aria-hidden />
      <div className="home-ambient home-ambient-right" aria-hidden />

      <AnimatedSection delay={0} variant="up">
        <HeroSection />
      </AnimatedSection>
      {/* <ScrollHeadlineSection /> */}
      <AnimatedSection delay={80} variant="up">
        <SaparyaConferenceSection />
      </AnimatedSection>
      <AnimatedSection delay={120} variant="left">
        <HowItWorks />
      </AnimatedSection>
      <AnimatedSection delay={140} variant="right">
        <ClientsSection />
      </AnimatedSection>
      <AnimatedSection delay={160} variant="up">
        <FeaturedTools />
      </AnimatedSection>

      <AnimatedSection delay={180} variant="left">
        <Faq />
      </AnimatedSection>
      {/* <ClientReviews /> */}
      <AnimatedSection delay={200} variant="right">
        <MobileApps />
      </AnimatedSection>
      <AnimatedSection delay={220} variant="up">
        <Footer />
      </AnimatedSection>
    </div>
  );
};

export default Home;